<template>
  <div
    style="
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    "
  >
    <van-nav-bar
      id="titlebar"
      title="统计"
      left-arrow
      fixed
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div
      style="
        width: 100%;
        height: 80px;
        margin-top: 46px;
        background-color: #fff;
        display: flex;
        flex-direction: row;
        gap: 20px;
        padding: 10px;
        box-sizing: border-box;
        border-bottom: 1px solid #ebedf0;
      "
    >
      <van-image
        width="50"
        height="50"
        radius="5"
        src="https://fastly.jsdelivr.net/npm/@vant/assets/cat.jpeg"
      />
      <div
        style="
          display: flex;
          flex: 1;
          width: 100%;
          flex-direction: row;
          margin-left: 10px;
          justify-content: space-around;
          align-items: center;
          box-sizing: border-box;
          overflow: auto;
        "
      >
        <span>{{ userInfo?.empName }}</span>
        <div
          style="
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: end;
          "
        >
          <!-- 时间选择 -->
          <div
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: end;
              gap: 6px;
              border: 1px solid #dcdee0;
              border-radius: 30px;
              margin-left: 20px;
              box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
              padding: 6px 15px;
            "
            @click="showDatePop = true"
          >
            <van-icon name="calendar-o" />
            <span>{{ signDate }}</span>
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>
    </div>
    <div style="flex: 1; height: 100%; overflow: auto">
      <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        pull-distance="300"
      >
        <van-empty
          v-if="clockList?.length === 0"
          description="暂无数据"
          style="height: 100%"
        />
        <van-list style="height: 100%">
          <div
            v-for="(item, index) in clockList"
            :key="index"
            style="
              display: flex;
              flex-direction: column;
              background-color: #fff;
              margin-bottom: 10px;
              box-sizing: border-box;
            "
          >
            <van-row
              justify="center"
              align="center"
              style="padding: 10px 10px 0px 10px"
            >
              <van-col span="8">
                <span>{{ moment(item.day).format("yyyy-MM-DD") }}</span>
              </van-col>
              <van-col span="8">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 5px;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                  "
                >
                  <span>应出勤</span>
                  <span>{{ item?.pt }}</span>
                  <span>小时</span>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    gap: 5px;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                  "
                >
                  <span>实际出勤</span>
                  <span>{{ item?.st }}</span>
                  <span>小时</span>
                </div>
              </van-col>
            </van-row>
            <!-- <div
              style="
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 5px;
                padding: 10px 10px 0px;
              "
            >
              <span>{{ moment(item.day).format("yyyy-MM-DD") }}</span>
            </div> -->
            <div
              style="
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 5px;
                box-sizing: border-box;
                padding: 10px;
              "
            >
              <ListLabelView
                :title="`上班时间${item?.k1?.st1}`"
                :clock-time="item?.k1?.sts1"
              />
              <ListLabelView
                :title="`下班时间${item?.k1?.st2}`"
                :clock-time="item?.k1?.sts2"
              />
              <ListLabelView
                :title="`上班时间${item?.k2?.st1}`"
                :clock-time="item?.k2?.sts1"
              />
              <ListLabelView
                :title="`下班时间${item?.k2?.st2}`"
                :clock-time="item?.k2?.sts2"
              />
              <ListLabelView
                :title="`上班时间${item?.k3?.st1}`"
                :clock-time="item?.k3?.sts1"
              />
              <ListLabelView
                :title="`下班时间${item?.k3?.st2}`"
                :clock-time="item?.k3?.sts2"
              />
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
  <van-popup v-model:show="showDatePop" position="bottom">
    <van-date-picker
      v-model="currentDate"
      :columns-type="['year', 'month']"
      title=""
      @confirm="confirmDate"
    />
  </van-popup>
</template>

<script setup lang="ts">
import { getAttendanceList } from "@/api/clockin";
import moment from "moment";
import { userAuthStore } from "@/store/auth";
import ListLabelView from "./components/ListLabelView.vue";

const common = userAuthStore();
const userInfo = ref(common.currUserData);

const clockList: any = ref([]);

// 标题栏返回
const onClickLeft = () => {
  window?.DFlutter?.postMessage("goBackToApp");
};

const refreshing = ref(false);
const onRefresh = () => {
  requestData();
};

// 选择时间
const currentDate = ref([
  moment().year().toString(),
  (moment().month() + 1).toString(),
]);
const showDatePop = ref(false);
const signDate = ref(moment().format("YYYY-MM"));
const confirmDate = () => {
  const [year, month] = currentDate.value;
  signDate.value = `${year}-${month}`;
  showDatePop.value = false;
  requestData();
};

const requestData = () => {
  const params = {
    attendanceMonth: moment(signDate.value).format("YYYYMM"),
    empId: common.currUserData?.empId,
  };
  // 打卡统计列表
  getAttendanceList(params)
    .then((res: any) => {
      refreshing.value = false;
      if (res && res.length > 0) {
        clockList.value = res;
      } else {
        clockList.value = [];
      }
    })
    .catch(() => {
      refreshing.value = false;
    });
};
onMounted(() => {
  refreshing.value = true;
  onRefresh();
});
</script>

<style scoped>
.tag {
  font-size: 16px;
  font-weight: normal;
}
.tag .highlight {
  font-weight: 700;
  color: #1989fa;
}
</style>
